import { dateCustom } from '../../../../components';
import { graficoCustomProduto, numberFormat, numberZero,paramsApi } from '../../../../helpers';
import api from '../../../../helpers/api';
import apiOld from '../../../../helpers/apiOld';
import apiV3 from '../../../../helpers/apiV3';
import { setFiltered } from '../../../../layout/redux/layoutActions';

export const setTotalAvaliacao = payload => ({
  type: 'INFO_GRAFICO_NPSCONCORRENTESPRODUTOS_TOTAL_AVALIACAO',
  payload
})


export const setFiltersProvisorio = payload => ({
  type: 'INFO_FILTERS_NPSCONCORRENTESPRODUTOS',
  payload
})

export const putFiltersProvisorio = payload => ({
  type: 'CHANGE_FILTERS_NPSCONCORRENTESPRODUTOS',
  payload
})

export const cleanFiltersProvisorio = () => ({
  type: 'CLEAN_FILTERS_NPSCONCORRENTESPRODUTOS',
})


export const setGraficoLoad = payload => ({
  type: 'LOAD_GRAFICO_NPSCONCORRENTESPRODUTOS',
  payload
})

export const setGrafico = payload => ({
  type: 'INFO_GRAFICO_NPSCONCORRENTESPRODUTOS',
  payload
})

export const setTooltipAtual = payload => ({
  type: 'INFO_TOOLTIP_ATUAL',
  payload
})

export const setTooltipAnterior = payload => ({
  type: 'INFO_TOOLTIP_ANTERIOR',
  payload
})

export const carregarGrafico = ({projetoID, grupo, params, typeSelect, idioma1, labelgraf}) => {
  
  return dispatch => {
    dispatch(setGraficoLoad(true))

    /*
    let paramsUrl = paramsApi({
      ...params, 
      projetoId: projetoID,
      Grupo: grupo?.name,  
      // Grupo: "2",   
      //   Grupo: grupo.nomeGrupo
      idioma: idioma1,
    })
    */
   let paramsInput = {
      ...params, 
      projetoId: projetoID,
      idioma: idioma1
    };

    if (grupo && grupo.name && grupo.name.trim() !== '') {
      paramsInput.Grupo = grupo.name;
    }

    let paramsUrl = paramsApi(paramsInput);

    //console.error('ENTROU EM CARREGARGRAFICO - PARTE 1');
    apiV3.get(`/front/GetRankingNpsProdutos${paramsUrl}`)
    .then(result => {

      if(result.data.totalAvaliacoes === 0){
        console.error('ENTROU EM TOTALAVALIAÇÕES = ZERO');
        dispatch([
          setGrafico({"totalAvaliacoes":0,"media":null,"desvio":null,"data":"","labels":null,"analise":null}),
          setTotalAvaliacao(0),
          setGraficoLoad(false)          
        ])
        return;
      }
      
      //const resultado = graficoCustom(result.data, params, true, labelgraf)
      const resultado = graficoCustomProduto(result.data, params, true, labelgraf)



      console.error('ENTROU EM TOTALAVALIAÇÕES DIFERENTE DE ZERO');
      console.error(resultado, 'RESULTADO LIDO:');
      //console.error('RESULTADO:' + result.data);
      //console.warn(result, 'carregarGrafico');
      dispatch([
        setGrafico(resultado),
        setTotalAvaliacao(result.data.totalAvaliacoes),
        setTooltipAtual(result.data.tooltipAtual),
        setTooltipAnterior(result.data.tooltipAnterior),
        setGraficoLoad(false)
      ])
      console.error('ATUALIZOU RESULTADO DEPOIS DE TOTALAVALIAÇÕES');
      console.error(resultado, 'RESULTADO LIDO:');
    })
    .catch(err => {
      console.error('************* ENTROU EM ERRO EM NPSCONCORRENTESPRODUTOSACTION');
      dispatch([
        setGrafico([]),
        setTotalAvaliacao(0),
        setGraficoLoad(false)
      ])
    });
  }
}

export const filterHandle = ({projetoID, grupo, params, typeSelect, filtersProvisorio, idioma, labelgraf}) => {
  const paramsCustom = {...params, ciclo: params?.ciclo?.ano ? params.ciclo : filtersProvisorio.ciclo}
  return dispatch => {
    let paramsFilter = filtersCustom({params: paramsCustom, typeSelect})
    const idioma1 = idioma;
    console.error('PROJETO-ID DENTTRO DE FILTER HANDLE: ' + projetoID);
    dispatch(setGraficoLoad(true))
    
    dispatch([
      setFiltered(paramsCustom),
      carregarGrafico({projetoID, grupo, params: paramsFilter, typeSelect, idioma1, labelgraf})
    ])
  }
}

export const filtersCustom = ({params, typeSelect}) => {
  let paramsFilter = {}
  if (typeSelect?.id === 'Ciclo') {
    if (params?.ciclo?.mesAno) {
      paramsFilter = {
        comparacao: params.compararCiclos.id === 'ativar'?true:false,
        intervalo: `${params.ciclo.ano}-${params.ciclo.mes}`,
      }
    }
  }
  if (typeSelect?.id === 'Data') {
    paramsFilter = {
      intervalo: `${dateCustom(params.dataInicial).data} ${dateCustom(params.dataFinal).data}`,
    }
  }
  return paramsFilter
}